import { StyleSheet, TouchableOpacity, View } from "react-native";
import { fp, hp, spV, wp } from "utils/normalise";

import { Colors } from "colors";
import { ORDERING_CHANNEL } from "utils/Constants";
import React from "react";
import VText from "components/VText";
import { useSelector } from "react-redux";

const AddressCard = (props) => {
    const { name, address, onPressEditBtn, item, onPressSelectBtn, selectedAddress } = props;

    return (
        <TouchableOpacity activeOpacity={0.8} onPress={onPressSelectBtn} style={Styles.cardContainer}>
            <View>
                <View
                    style={{
                        width: 20,
                        height: 20,
                        borderRadius: 100,
                        borderWidth: 2,
                        borderColor: selectedAddress?.id == item?.id ? "rgba(33, 36, 39, 1)" : "rgba(33, 36, 39, 0.3)",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {selectedAddress?.id == item?.id && (
                        <View
                            style={{
                                width: 10,
                                height: 10,
                                borderRadius: 100,
                                backgroundColor: "rgba(33, 36, 39, 1)",
                            }}
                        />
                    )}
                </View>
            </View>
            <View style={Styles.nameAddContainer}>
                <VText style={Styles.nameText}>{name}</VText>
                <VText style={Styles.addText}>{address}</VText>
                <TouchableOpacity onPress={onPressEditBtn} style={Styles.editBtn}>
                    <VText>Edit</VText>
                </TouchableOpacity>
            </View>
        </TouchableOpacity>
    );
};
export default AddressCard;

const Styles = StyleSheet.create({
    cardContainer: {
        paddingVertical: spV(16),
        justifyContent: "space-between",
        flexDirection: "row",
        borderBottomWidth: 1,
        paddingBottom: spV(16),
        borderColor: "rgba(223, 223, 223, 1)",
    },
    editBtn: {
        width: wp(50),
        alignItems: "center",
        justifyContent: "center",
        borderWidth: 1,
        borderColor: Colors.black60,
        paddingVertical: spV(4),
    },
    nameAddContainer: {
        width: "92%",
    },
    filledIcon: {
        height: 24,
        width: 24,
    },
    nameText: {
        fontWeight: "550",
        fontSize: fp(16),
        marginBottom: spV(8),
    },
    addText: {
        fontWeight: "350",
        color: Colors.grey66,
        fontSize: fp(16),
        marginBottom: spV(8),
    },
});
